module.exports = __webpack_public_path__ + "img/car-orange.b97ac7d.webp";